module.exports = __webpack_public_path__ + "static/media/sysdesign.8f00588d.png";